<script setup lang="ts">
  import { onMounted, ref } from "vue";
  import aiPoster from "~/assets/images/home/new/ai-video-bg.png";
  import fasouPoster from "~/assets/images/home/new/fasou-video-bg.png";
  import lvzhuPoster from "~/assets/images/home/new/lvzhu-video-bg.png";
  import AdvertiseModal from "~/components/deli-module/AdvertiseModal.vue";
  import { useApi } from "~/composables/useApi";
  import { FaSou, LvZhu, XiaoLiAi } from "~/enum/cdn";
  import { DATA_URL, DLS_URL, OPEN_URL } from "~/env";
  import Logger from "~/utils/logger";

  const isClient = typeof window !== "undefined";

  definePageMeta({
    layout: "nav-layout",
  });

  const api = useApi();

  const NEWS_TABS = [
    { label: "公司动态", value: "company" },
    { label: "行业资讯", value: "industry" },
    { label: "法律知识", value: "literacy" },
  ];
  const newsType = ref("industry");
  const newsActiveTab = ref("0");
  const newsTypeList = ref<any[]>([]);
  const newsItems = ref<any[]>([]);
  const newsLoading = ref(false);
  const newsTotalPage = ref(0);
  const newsPageNo = ref(1);
  const NEWS_PAGE_SIZE = 3;

  const loadNewsTypeList = async () => {
    try {
      const res = await api.newsQueryType(newsType.value);
      newsTypeList.value = [{ value: "0", label: "全部" }, ...res];
    } catch (e) {
      console.error(e);
    }
  };

  const loadNewsData = async () => {
    newsLoading.value = true;
    try {
      const params: any = {
        pageNo: newsPageNo.value,
        pageSize: NEWS_PAGE_SIZE,
        type: newsType.value,
        category: newsActiveTab.value === "0" ? "" : newsActiveTab.value,
      };
      const { data, totalCount } = await api.newsQuery(params);
      newsItems.value = data;
      newsTotalPage.value = Math.ceil(totalCount / NEWS_PAGE_SIZE);
    } catch (e) {
      console.error(e);
    } finally {
      newsLoading.value = false;
    }
  };

  const onNewsTabChange = async (tab: string) => {
    newsType.value = tab;
    newsActiveTab.value = "0";
    newsPageNo.value = 1;
    await loadNewsTypeList();
    await loadNewsData();
  };

  const onNewsCategoryChange = async (category: string) => {
    newsActiveTab.value = category;
    newsPageNo.value = 1;
    await loadNewsData();
  };

  const onNewsPageChange = async (page: number) => {
    if (page < 1 || page > newsTotalPage.value) return;
    newsPageNo.value = page;
    await loadNewsData();
  };

  const MAX_VISIBLE_DOTS = 7;
  const visiblePages = computed(() => {
    const total = newsTotalPage.value;
    if (total <= MAX_VISIBLE_DOTS) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const half = Math.floor(MAX_VISIBLE_DOTS / 2);
    let start = newsPageNo.value - half;
    let end = newsPageNo.value + half;
    if (start < 1) {
      start = 1;
      end = MAX_VISIBLE_DOTS;
    }
    if (end > total) {
      end = total;
      start = total - MAX_VISIBLE_DOTS + 1;
    }
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  });

  //产品跳转埋点
  const onTrigerProduct = (name: string) => {
    switch (name) {
      case "小理AI":
        Logger.event("首页菜单_小理AI");
        window.open("/ai", "_blank");
        break;
      case "得理律助":
        Logger.event("首页菜单_得理律助");
        break;
      case "得理法搜":
        Logger.event("首页菜单_得理法搜");
        break;
      default:
        break;
    }
  };

  //免费体验跳转埋点
  const onTrigerFreeTry = (name: string) => {
    switch (name) {
      case "小理AI":
        Logger.event("首页内容_免费体验_小理AI");
        window.open("/ai", "_blank");
        break;
      case "得理律助":
        Logger.event("首页内容_免费体验_得理律助");
        break;
      case "得理法搜":
        Logger.event("首页内容_免费体验_得理法搜");
        break;
      case "开放平台":
        Logger.event("首页内容_免费体验_开放平台");
        window.open(OPEN_URL, "_blank");
        break;
      default:
        break;
    }
  };

  //视频播放次数统计
  const onPlayVideo = (name: string) => {
    switch (name) {
      case "小理AI":
        Logger.event("首页视频_小理AI");
        break;
      case "得理律助":
        Logger.event("首页视频_得理律助");
        break;
      case "得理法搜":
        Logger.event("首页视频_得理法搜");
        break;
      default:
        break;
    }
  };

  onMounted(async () => {
    if (isClient) {
      await loadNewsTypeList();
      await loadNewsData();
    }
  });
</script>

<template>
  <div class="container">
    <div class="banner-home tw-w-full">
      <div class="banner-content tw-px-[16px]">
        <div class="tw-pt-[168px] tw-text-center sm:tw-pt-[238px] lg:tw-pt-[136px] lg:tw-pt-[209px] 2xl:tw-pt-[164px]">
          <div
            class="title-lg text-26px tw-text-[32px] tw-font-semibold tw-text-white sm:tw-text-[44px] md:tw-text-[66px] 2xl:tw-text-[86px]">
            <h1
              class="text-34px tw-mb-[8px] tw-text-[44px] tw-font-semibold tw-text-white sm:tw-text-[58px] md:tw-text-[78px]
                2xl:tw-text-[98px]">
              得理科技
            </h1>
            <div class="tw-flex tw-items-center tw-justify-center">
              <div>
                <img
                  class="ai-lawyer-txt tw-mr-[20px] tw-h-[41px] tw-w-[160px] tw-align-middle sm:tw-h-[54px] sm:tw-w-[210px] md:tw-h-[89px]
                    md:tw-w-[346px] 2xl:tw-h-[121px] 2xl:tw-w-[471px]"
                  src="~/assets/images/home/new/ai-lawyer-color-icon.svg" />
              </div>
              <span>一站式服务平台</span>
            </div>
          </div>
          <div
            class="sub-title tw-mt-[42px] tw-flex tw-flex-col tw-text-[16px] tw-text-[#ffffff]/[.84] sm:tw-mt-[48px] sm:tw-text-[20px]
              md:tw-block xl:tw-mt-[48px] xl:tw-text-[24px]">
            <span>基于法律大模型开发的智慧法律系统</span>
            <span class="tw-mt-[10px] md:tw-ml-[12px] md:tw-mt-0">为用户提供“AI+律师”的解决方案</span>
          </div>
          <div
            class="navigation-product tw-mt-[116px] tw-flex tw-justify-center tw-text-[24px] sm:tw-mt-[89px] xl:tw-mt-[106px]">
            <div
              class="link-ai link-btn tw-h-[44px] tw-w-[133px] tw-rounded-[3px] tw-text-[20px] tw-font-semibold tw-leading-[44px]
                sm:tw-h-[60px] sm:tw-w-[165px] sm:tw-rounded-[3px] sm:tw-text-[24px] sm:tw-leading-[60px] xl:tw-h-[72px] xl:tw-w-[200px]
                xl:tw-rounded-[4px] xl:tw-leading-[72px]"
              @click="onTrigerProduct('小理AI')">
              <a>小理AI</a>
            </div>
            <div
              class="link-paralegal link-btn tw-ml-[26px] tw-h-[44px] tw-w-[133px] tw-rounded-[3px] tw-text-[20px] tw-font-semibold
                tw-leading-[44px] sm:tw-ml-[28px] sm:tw-h-[60px] sm:tw-w-[165px] sm:tw-rounded-[3px] sm:tw-text-[24px]
                sm:tw-leading-[60px] xl:tw-h-[72px] xl:tw-w-[200px] xl:tw-rounded-[4px] xl:tw-leading-[72px]"
              @click="onTrigerProduct('得理法搜')">
              <a :href="DATA_URL" target="_blank">得理法搜</a>
            </div>
            <div
              class="link-search link-btn tw-ml-[26px] tw-h-[44px] tw-w-[133px] tw-rounded-[3px] tw-text-[20px] tw-font-semibold
                tw-leading-[44px] sm:tw-ml-[28px] sm:tw-h-[60px] sm:tw-w-[165px] sm:tw-rounded-[3px] sm:tw-text-[24px]
                sm:tw-leading-[60px] xl:tw-h-[72px] xl:tw-w-[200px] xl:tw-rounded-[4px] xl:tw-leading-[72px]"
              @click="onTrigerProduct('得理律助')">
              <a :href="DLS_URL" target="_blank">得理律助</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="corporate-achievements tw-w-full tw-px-[16px]">
      <div
        class="achievements-content tw-h-[148px] tw-h-auto tw-w-full tw-px-[16px] tw-text-white sm:tw-px-[97px] md:tw-px-[155px]
          lg:tw-h-[90px] lg:tw-px-[138px] 2xl:tw-px-[350px]">
        <div class="tw-hidden tw-size-full lg:tw-block">
          <div class="achievements-md tw-flex tw-size-full tw-items-center tw-justify-between">
            <div class="achievements-item tw-flex tw-items-center">
              <div class="tw-mr-[10px] tw-h-[30px] tw-w-[30px]">
                <img class="tw-size-full" src="~/assets/images/home/new/high-technology-icon.svg" />
              </div>
              <div><span class="tw-align-text-top">国家高新技术企业</span></div>
            </div>
            <div class="achievements-item tw-flex tw-items-center md:tw-pl-[145px] lg:tw-pl-0">
              <div class="tw-mr-[10px] tw-h-[30px] tw-w-[30px]">
                <img class="tw-size-full" src="~/assets/images/home/new/artificial-intelligence-icon.svg" />
              </div>
              <div><span class="tw-align-text-top">中科院深圳先进院-得理法律人工智能实验室</span></div>
            </div>
            <div class="achievements-item tw-flex tw-items-center">
              <div class="tw-mr-[10px] tw-h-[30px] tw-w-[30px]">
                <img class="tw-size-full" src="~/assets/images/home/new/medal-icon.svg" />
              </div>
              <div><span class="tw-align-text-top">连续三年高交会优秀产品奖</span></div>
            </div>
            <div class="achievements-item tw-flex tw-items-center">
              <div class="tw-mr-[10px] tw-h-[30px] tw-w-[30px]">
                <img class="tw-size-full" src="~/assets/images/home/new/patent-icon.svg" />
              </div>
              <div><span class="tw-align-text-top">18+AI专利技术</span></div>
            </div>
          </div>
        </div>
        <div class="tw-size-full lg:tw-hidden">
          <div
            class="achievements-sm deli-mx-auto tw-flex tw-h-full tw-items-center tw-justify-between tw-py-2 sm:tw-mx-0 sm:tw-w-full
              sm:tw-flex-row sm:tw-py-0 lg:tw-hidden">
            <div class="achievements-sm-item tw-flex tw-flex-col">
              <div class="achievements-item tw-flex tw-items-center">
                <div class="tw-mr-[10px] tw-h-[30px] tw-w-[30px]">
                  <img class="tw-size-full" src="~/assets/images/home/new/high-technology-icon.svg" />
                </div>
                <div><span class="tw-align-text-top">国家高新技术企业</span></div>
              </div>
              <div class="achievements-item deli-mt-0 tw-mt-1 tw-mt-[28px] tw-flex tw-items-center">
                <div class="tw-mr-[10px] tw-h-[30px] tw-w-[30px]">
                  <img class="tw-size-full" src="~/assets/images/home/new/medal-icon.svg" />
                </div>
                <div><span class="tw-align-text-top">连续三年高交会优秀产品奖</span></div>
              </div>
            </div>
            <div class="achievements-sm-item tw-flex tw-flex-col">
              <div class="achievements-item tw-flex tw-items-center">
                <div class="tw-mr-[10px] tw-h-[30px] tw-w-[30px]">
                  <img class="tw-size-full" src="~/assets/images/home/new/artificial-intelligence-icon.svg" />
                </div>
                <div><span class="tw-align-text-top">中科院深圳先进院-得理法律人工智能实验室</span></div>
              </div>
              <div
                class="achievements-item deli-mt-0 deli-align-self tw-mt-1 tw-mt-[28px] tw-flex tw-items-center tw-self-center">
                <div class="tw-mr-[10px] tw-h-[30px] tw-w-[30px]">
                  <img class="tw-size-full" src="~/assets/images/home/new/patent-icon.svg" />
                </div>
                <div><span class="tw-align-text-top">18+AI专利技术</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="products-wrapper">
      <div class="legal-ai tw-w-full tw-px-[27px] tw-text-justify">
        <div class="ai-content tw-w-full tw-pt-[107px] lg:tw-pt-[99px]">
          <div class="ai-divide">
            <div class="tw-flex tw-items-center tw-justify-center">
              <div
                class="divide-line tw-mr-[10px] tw-h-0 tw-w-[70px] tw-rotate-[-180deg] sm:tw-mr-[12px] sm:tw-w-[110px] md:tw-mr-[18px]
                  md:tw-w-[140px] xl:tw-mr-[28px] xl:tw-w-[217px]"></div>
              <div class="ai-model-title tw-flex tw-items-center tw-justify-center">
                <div class="tw-h-[20] tw-w-[21px] sm:tw-h-[24px] sm:tw-w-[26px] xl:tw-h-[31px] xl:tw-w-[33px]">
                  <img class="tw-size-full tw-align-top" src="~/assets/images/home/new/legal-ai-divide.png" />
                </div>
                <h3 class="tw-mx-[6px] tw-mb-0 tw-text-center sm:tw-mx-[8px] md:tw-mx-[10px] xl:tw-mx-[13px]">
                  <span
                    class="divide-title-color tw-text-[20px] tw-font-bold sm:tw-text-[21px] md:tw-text-[24px] xl:tw-text-[32px]"
                    >得理法律大模型-“AI+律师”一站式服务平台</span
                  >
                </h3>
                <div class="tw-h-[20] tw-w-[21px] sm:tw-h-[24px] sm:tw-w-[26px] xl:tw-h-[31px] xl:tw-w-[33px]">
                  <img
                    class="rotate-180 tw-size-full tw-align-top"
                    src="~/assets/images/home/new/legal-ai-divide.png" />
                </div>
              </div>
              <div
                class="divide-line tw- tw-ml-[10px] tw-h-0 tw-w-[70px] sm:tw-ml-[12px] sm:tw-w-[110px] md:tw-ml-[18px] md:tw-w-[140px]
                  xl:tw-ml-[28px] xl:tw-w-[217px]"></div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="products-sticky-nav tw-sticky tw-top-[0px] tw-z-[9] tw-w-full tw-px-[16px] tw-py-[12px] sm:tw-px-[27px] sm:tw-py-[20px]">
        <div class="ai-product-content tw-grid tw-w-full tw-grid-cols-2 tw-gap-[10px] lg:tw-grid-cols-4 lg:tw-gap-x-3">
          <div class="ai-product-item">
            <div class="producet-size tw-flex tw-w-[81%] tw-items-center">
              <div class="product-icon">
                <img class="tw-h-[70px] tw-w-[65px]" src="~/assets/images/home/new/ai.png" />
              </div>
              <div class="tw-flex tw-flex-col">
                <div class="tw-text-[20px] tw-font-bold tw-text-[#1f1f1f]">小理AI</div>
                <div class="tw-mt-[4px] tw-text-[#828596]">7*24智能法律专家</div>
                <div class="paralegal-free-trial tw-mt-[14px]" @click="onTrigerFreeTry('小理AI')">
                  <a>免费体验</a>
                </div>
              </div>
            </div>
          </div>
          <div class="ai-product-item">
            <div class="producet-size tw-flex tw-w-[81%] tw-items-center">
              <div class="product-icon">
                <img class="tw-h-[51px] tw-w-[50px]" src="~/assets/images/home/new/search.png" />
              </div>
              <div class="tw-flex tw-flex-col tw-text-[#828596]">
                <div class="tw-text-[20px] tw-font-bold tw-text-[#1f1f1f]">得理法搜</div>
                <div class="tw-mt-[4px] tw-text-[#828596]">法律难题 就找得理法搜</div>
                <div class="paralegal-free-trial tw-mt-[14px]" @click="onTrigerFreeTry('得理法搜')">
                  <a :href="DATA_URL" target="_blank">免费体验</a>
                </div>
              </div>
            </div>
          </div>
          <div class="ai-product-item">
            <div class="producet-size tw-flex tw-w-[81%] tw-items-center">
              <div class="product-icon">
                <img class="tw-h-[44px] tw-w-[63px]" src="~/assets/images/home/new/paralegal.png" />
              </div>
              <div class="tw-flex tw-flex-col">
                <div class="tw-text-[20px] tw-font-bold tw-text-[#1f1f1f]">得理律助</div>
                <div class="tw-mt-[4px] tw-text-[#828596]">专为律师打造的智能助手</div>
                <div class="paralegal-free-trial tw-mt-[14px]" @click="onTrigerFreeTry('得理律助')">
                  <a :href="DLS_URL" target="_blank">免费体验</a>
                </div>
              </div>
            </div>
          </div>
          <div class="ai-product-item">
            <div class="producet-size tw-flex tw-w-[81%] tw-items-center">
              <div class="product-icon">
                <img class="tw-h-[55px] tw-w-[47px]" src="~/assets/images/home/new/information.png" />
              </div>
              <div class="tw-flex tw-flex-col">
                <div class="tw-text-[20px] tw-font-bold tw-text-[#1f1f1f]">开放平台</div>
                <div class="tw-mt-[4px] tw-text-[#828596]">构建您自己的法律行业大模型</div>
                <div class="paralegal-free-trial tw-mt-[14px]" @click="onTrigerFreeTry('开放平台')">
                  <a>免费体验</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="legal-ai tw-w-full tw-px-[27px] tw-text-justify">
        <div class="ai-product tw-w-full">
          <div class="ai-introduction tw-w-full">
            <div
              class="ai-xiaoli-content tw-relative tw-w-full tw-overflow-hidden tw-pb-[200px] tw-pt-[160px] xl:tw-pb-[278px]">
              <div class="ai-xiaoli-title tw-flex tw-items-center tw-justify-center">
                <div class="ai-xiaoli-icon tw-mr-[24px] sm:tw-mr-[29px]">
                  <img class="tw-h-[80px] tw-w-[74px]" src="~/assets/images/home/new/ai.png" />
                </div>
                <div class="tw-flex tw-flex-col">
                  <h1 class="text-30px tw-text-[40px] tw-font-bold tw-text-[#1f1f1f]">小理AI</h1>
                  <h3 class="text-18px tw-mt-[4px] tw-text-[24px] tw-text-[#828596]">
                    专业法律AI，业内领先的法律AI大模型
                  </h3>
                </div>
              </div>
              <div class="product-features tw-mt-[60px] tw-flex tw-w-full tw-justify-center">
                <div
                  class="product-features-content tw-mx-auto tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center xl:tw-flex-row">
                  <div class="product-features-poster tw-mb-[55px] xl:tw-mb-0 xl:tw-mr-[80px]">
                    <div
                      class="features-poster-item tw-flex tw-max-h-[396px] tw-max-w-[730px] tw-items-center tw-justify-center tw-rounded-[16px]
                        tw-bg-white xl:tw-max-w-[678px]">
                      <div class="tw-flex tw-size-full tw-items-center tw-rounded-[8px] tw-p-[12px] sm:tw-p-[16px]">
                        <video
                          id="video1"
                          class="video-player tw-size-full tw-rounded-[8px]"
                          controls
                          :poster="aiPoster"
                          controlslist="noplaybackrate nodownload"
                          @play="onPlayVideo('小理AI')">
                          <source :src="XiaoLiAi" type="video/mp4" />
                        </video>
                      </div>
                    </div>
                    <div class="tw-mt-[30px]">
                      <span class="text-16px tw-mr-[10px] tw-text-[18px] tw-text-[#999999]">适合用户</span>
                      <span class="text-18px tw-text-[20px] tw-text-[#333333]">法律从业者 / 企业 / 个人</span>
                    </div>
                  </div>
                  <div class="product-features-introduction tw-max-w-[730px]">
                    <div class="features-introduction-item text-18px tw-text-[16px]">
                      <div>
                        <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">AI对话：</span>
                        <span class="tw-text-[#5a5d66]"
                          >提供7×24小时AI法律咨询，实时解答婚姻、房产、劳动用工、企业合规等法律问题，复杂问题无缝衔接律师支持，AI还可精准理解意图，一键直达其他更匹配的功能模块。</span
                        >
                      </div>
                      <div class="tw-mt-[18px]">
                        <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">法律研究：</span>
                        <span class="tw-text-[#5a5d66]"
                          >智能拆解法律问题，联动全库检索并自动生成结构化报告，重构从问题定位到成果输出的全流程研究闭环。</span
                        >
                      </div>
                      <div class="tw-mt-[18px]">
                        <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">AI检索：</span>
                        <span class="tw-text-[#5a5d66]"
                          >读取5亿+全域法律数据，像聊天一样进行法律检索，实现法规与类案高效精准定位，同步输出检索报告。</span
                        >
                      </div>
                      <div class="tw-mt-[18px]">
                        <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">合同生成：</span>
                        <span class="tw-text-[#5a5d66]"
                          >通过"输入-确定大纲-生成-修改"的可控步骤，将模糊的生成动作透明化，确保生成的合同兼具法律专业性与业务场景灵活适配性。</span
                        >
                      </div>
                      <div class="tw-mt-[18px]">
                        <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">合同审查：</span>
                        <span class="tw-text-[#5a5d66]"
                          >合同总体审查与条款逐条审查结合，自定义审查规则与系统配置审查规则结合，并支持智能选择审查主体立场，精准识别合同风险，可一键完成修订。</span
                        >
                      </div>
                      <div class="tw-mt-[18px]">
                        <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">法律文书：</span>
                        <span class="tw-text-[#5a5d66]"
                          >高效生成各类诉讼文书与非诉讼文书，并支持67类要素文书与传统文书的自由生成转换。</span
                        >
                      </div>
                      <div class="tw-mt-[18px]">
                        <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">文本分析：</span>
                        <span class="tw-text-[#5a5d66]"
                          >一键上传多份文档，精准定位场景化需求、提炼文档关键信息并进行深度解析（如案件分析、证据分析、合同分析），快速掌握复杂材料核心要旨。</span
                        >
                      </div>
                      <div class="tw-mt-[18px]">
                        <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">问律师：</span>
                        <span class="tw-text-[#5a5d66]"
                          >与AI协同提供法律咨询服务，根据律师的执业领域、案例经验、执业年限、所在律所等数据为客户精准推荐律师，让律师精准获客，让客户找律师不再难。</span
                        >
                      </div>
                      <div class="tw-mt-[18px]">
                        <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">专业模型：</span>
                        <span class="tw-text-[#5a5d66]"
                          >融合特定法律领域的海量知识、实务规则和工作流，提供高度精准、场景闭环的“一站式”智能解决方案。</span
                        >
                      </div>
                    </div>
                    <div class="free-trial tw-mt-[76px] tw-flex tw-justify-center xl:tw-block">
                      <nuxt-link to="/ai" target="_blank">免费体验</nuxt-link>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="triangle-bg tw-absolute tw-right-[-880px] tw-top-[560px] tw-h-[839px] tw-w-[839px] sm:tw-right-[-730px]
                  sm:tw-top-[560px] md:tw-right-[-820px] md:tw-top-[460px] lg:tw-right-[-520px] lg:tw-top-[500px] xl:tw-right-[-500px]
                  xl:tw-top-[170px] 2xl:tw-right-[-460px] 2xl:tw-top-[170px]"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="deli-search tw-w-full tw-px-[27px] tw-text-justify">
        <div class="deli-search-content tw-w-full tw-pb-[201px] tw-pt-[127px] xl:tw-pb-[246px] 2xl:tw-pb-[290px]">
          <div class="deli-search-title tw-flex tw-items-center tw-justify-center">
            <div class="deli-search-icon tw-mr-[14px] sm:tw-mr-[29px]">
              <img class="tw-h-[60px] tw-w-[60px]" src="~/assets/images/home/new/search.png" />
            </div>
            <div class="tw-flex tw-flex-col">
              <h1 class="text-30px tw-text-[40px] tw-font-bold tw-text-[#1f1f1f]">得理法搜</h1>
              <h3 class="text-18px tw-mt-[4px] tw-text-[24px] tw-text-[#828596]">
                法律大数据集成法律大模型，更专业、更全面、更AI的法律数据库
              </h3>
            </div>
          </div>
          <div class="search-features tw-mt-[60px] tw-w-full">
            <div class="search-features-content tw-flex tw-flex-col tw-items-center tw-justify-center xl:tw-flex-row">
              <div class="search-features-introduction tw-max-w-[730px] xl:tw-mr-[80px]">
                <div class="features-introduction-item text-18px tw-text-[20px]">
                  <div>
                    <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">全域法律数据：</span>
                    <span class="tw-text-[#5a5d66]"
                      >覆盖案例、法规、观点、专利、商标、域名等5亿+全域法律数据，数据全面，实时更新。</span
                    >
                  </div>
                  <div class="tw-mt-[36px]">
                    <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">专业法律检索：</span>
                    <span class="tw-text-[#5a5d66]"
                      >语义检索、关键词检索、长文本检索多重检索模式加持，还支持类案检索总结、智能摘要、裁判要点、时间轴等功能，检索更精准高效。</span
                    >
                  </div>
                  <div class="tw-mt-[36px]">
                    <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">类案检索报告：</span>
                    <span class="tw-text-[#5a5d66]"
                      >智能阅读裁判文书，一键生成AI智能总结的类案报告，并提供导航大纲与贴合实务的检索报告模板，快速把握裁判要点、定位关键法规，显著提升法律研究、庭前准备效率。</span
                    >
                  </div>
                  <div class="tw-mt-[36px]">
                    <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">法律资讯推荐：</span>
                    <span class="tw-text-[#5a5d66]"
                      >整合新法速递、法律观点、全国商机、法律新闻等不同媒体平台的法律资讯，实时更新，提供个性化订阅服务。</span
                    >
                  </div>
                  <div class="tw-mt-[36px]">
                    <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">智能数字名片：</span>
                    <span class="tw-text-[#5a5d66]"
                      >智能识别纸质名片、个人简介智能完善、AI专属形象塑造、精准链接法律需求、打通案源拓展渠道。</span
                    >
                  </div>
                </div>
                <div class="free-trial tw-mt-[76px] tw-flex tw-justify-center xl:tw-block">
                  <a :href="DATA_URL" target="_blank">免费体验</a>
                </div>
              </div>
              <div class="search-features-poster tw-order-first tw-mb-[55px] tw-pt-[7px] xl:tw-order-last xl:tw-mb-0">
                <div
                  class="search-poster-item tw-flex tw-max-h-[396px] tw-max-w-[730px] tw-justify-center tw-rounded-[16px] tw-bg-white
                    xl:tw-max-w-[677px]">
                  <div class="tw-flex tw-size-full tw-items-center tw-rounded-[8px] tw-p-[12px] sm:tw-p-[16px]">
                    <video
                      id="video2"
                      class="video-player tw-size-full tw-rounded-[8px]"
                      :poster="fasouPoster"
                      controls
                      controlslist="noplaybackrate nodownload"
                      @play="onPlayVideo('得理法搜')">
                      <source :src="FaSou" type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div class="tw-mt-[30px]">
                  <span class="text-16px tw-mr-[10px] tw-text-[18px] tw-text-[#999999]">适合用户</span>
                  <span class="text-18px tw-text-[20px] tw-text-[#333333]">法律从业者 / 企业 / 个人</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="deli-paralegal tw-w-full tw-px-[27px] tw-text-justify">
        <div
          class="deli-paralegal-content tw-relative tw-w-full tw-overflow-hidden tw-pb-[200px] tw-pt-[120px] xl:tw-pb-[246px]">
          <div class="deli-paralegal-title tw-flex tw-items-center tw-justify-center">
            <div class="deli-paralegal-icon tw-mr-[18px] sm:tw-mr-[29px]">
              <img class="tw-h-[48px] tw-w-[70px]" src="~/assets/images/home/new/paralegal.png" />
            </div>
            <div class="tw-flex tw-flex-col">
              <h1 class="text-30px tw-text-[40px] tw-font-bold tw-text-[#1f1f1f]">得理律助</h1>
              <h3 class="text-18px tw-mt-[4px] tw-text-[24px] tw-text-[#828596]">专为律师打造的智能助手</h3>
            </div>
          </div>
          <div class="paralegal-features tw-mt-[60px] tw-w-full">
            <div
              class="paralegal-features-content tw-flex tw-flex-col tw-items-center tw-justify-center xl:tw-flex-row">
              <div class="paralegal-features-poster tw-mb-[72px] xl:tw-mb-0 xl:tw-mr-[80px]">
                <div
                  class="features-poster-item tw-flex tw-max-h-[396px] tw-max-w-[730px] tw-justify-center tw-rounded-[16px] tw-bg-white
                    xl:tw-max-w-[678px]">
                  <div class="tw-flex tw-size-full tw-items-center tw-rounded-[8px] tw-p-[12px] sm:tw-p-[16px]">
                    <video
                      id="video3"
                      class="video-player tw-size-full tw-rounded-[8px]"
                      :poster="lvzhuPoster"
                      controls
                      controlslist="noplaybackrate nodownload"
                      @play="onPlayVideo('得理律助')">
                      <source :src="LvZhu" type="video/mp4" />
                    </video>
                  </div>
                </div>
                <div class="tw-mt-[30px]">
                  <span class="text-16px tw-mr-[10px] tw-text-[18px] tw-text-[#999999]">适合用户</span>
                  <span class="text-18px tw-text-[20px] tw-text-[#333333]">法律团队 / 律所 / 独立律师</span>
                </div>
              </div>
              <div class="paralegal-features-introduction tw-max-w-[730px]">
                <div class="features-introduction-item text-18px tw-text-[20px]">
                  <div>
                    <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">案源拓展：</span>
                    <span class="tw-text-[#5a5d66]"
                      >通过数字名片、案源广场、商机推送与内部市场等方式，帮助律师低成本精准触达客户，实现案源批量获取。</span
                    >
                  </div>
                  <div class="tw-mt-[36px]">
                    <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">智慧办案：</span>
                    <span class="tw-text-[#5a5d66]"
                      >集成法律大数据和法律大模型，全面覆盖律师的真实实务场景，通过法律检索、法律研究、法律文书、合同生成、合同审查等AI功能，智能辅助办案。</span
                    >
                  </div>
                  <div class="tw-mt-[36px]">
                    <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">案件管理：</span>
                    <span class="tw-text-[#5a5d66]"
                      >通过案件、客户、项目、时间的可视化管理，实现团队间的智能协作，为律师建立一个适应AI时代的案件管理工作流。</span
                    >
                  </div>
                  <div class="tw-mt-[36px]">
                    <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">知识管理：</span>
                    <span class="tw-text-[#5a5d66]"
                      >通过云盘DOC、知识库等功能实现知识沉淀与智能检索，帮助律师及律所高效管理案件资料、合同模板等核心资产，构建可复用的专属知识体系。</span
                    >
                  </div>
                  <div class="tw-mt-[36px]">
                    <span class="tw-mr-[6px] tw-font-semibold tw-text-[#333333]">小理智能体：</span>
                    <span class="tw-text-[#5a5d66]"
                      >7×24小时AI助理与数字分身，辅助律师完成营销拓客、客户服务、服务报告、利冲智能检索等工作，提升服务响应与拓客效率。</span
                    >
                  </div>
                </div>
                <div class="free-trial tw-mt-[64px] tw-flex tw-justify-center xl:tw-block">
                  <a :href="DLS_URL" target="_blank">免费体验</a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="triangle-bg tw-absolute tw-left-[-590px] tw-top-[710px] tw-h-[839px] tw-w-[839px] sm:tw-left-[-620px] sm:tw-top-[710px]
              xl:tw-left-[-630px] xl:tw-top-[390px]"></div>
        </div>
      </div>
      <div
        class="more-info tw-w-full tw-bg-[url('~/assets/images/home/new/more-bg.png')] tw-bg-cover tw-bg-center tw-px-[27px]
          tw-text-justify">
        <div class="api-integration tw-w-full">
          <div class="api-integration-content tw-pt-[120px]">
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
              <div class="title tw-flex tw-flex-col tw-items-center">
                <h1 class="text-30px tw-text-[36px] tw-font-semibold tw-text-[#333333]">得理开放API接入</h1>
                <div class="tw-mt-[7px] tw-h-[6px] tw-w-[32px] tw-bg-[#3555fe]"></div>
                <h3 class="text-20px tw-mt-[24px] tw-text-center tw-text-[24px] tw-font-normal">
                  让您快速拥抱法律大模型，掌握最新法律工具
                </h3>
              </div>
              <div class="tw-mt-[32px] tw-w-full md:tw-mt-[48px] xl:tw-mt-[120px]">
                <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center xl:tw-flex-row">
                  <div class="api-txt tw-max-w-[760px] tw-text-justify xl:tw-mr-[110px]">
                    <div class="text-30px tw-text-[40px] tw-font-semibold">开放能力</div>
                    <div class="text-18px text-leading-45 tw-mt-[16px] tw-text-[22px] tw-leading-[53px]">
                      <span class="tw-font-semibold">AI大模型:</span>
                      <span>提供智能问答、文本生成、文本分析的API接口服务</span>
                    </div>
                    <div class="text-18px text-leading-45 tw-mt-[10px] tw-text-[22px] tw-leading-[53px]">
                      <span class="tw-font-semibold">智能法律检索:</span>
                      <span>提供智能裁判文书、法规、观点、专利、商标数据检索和详情查看API接口服务</span>
                    </div>
                  </div>
                  <div
                    class="api-show tw-mt-[70px] tw-flex tw-w-full tw-flex-row tw-justify-center tw-text-[26px] tw-text-[#333333] sm:tw-text-[26px]
                      sm:tw-text-[32px] xl:tw-mt-0 xl:tw-w-auto">
                    <div class="api-show-item tw-w-[280px] tw-max-w-[320px] sm:tw-min-w-[340px]">
                      <div class="tw-flex tw-items-center tw-pl-[16px] sm:tw-pl-[20px] md:tw-pl-[26px] xl:tw-pl-[36px]">
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/professional-data.png" />
                        </div>
                        <div class="sub-title tw-mx-[8px] sm:tw-mx-[10px] md:tw-ml-[14px] md:tw-mr-[24px]">
                          全域专业数据
                        </div>
                      </div>
                      <div class="color-line tw-my-[72px] tw-w-full"></div>
                      <div class="tw-flex tw-items-center tw-pl-[16px] sm:tw-pl-[20px] md:tw-pl-[26px] xl:tw-pl-[36px]">
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/money.png" />
                        </div>
                        <div class="sub-title tw-mx-[8px] sm:tw-mx-[10px] md:tw-ml-[14px] md:tw-mr-[24px]">
                          低成本接入
                        </div>
                      </div>
                    </div>
                    <div
                      class="api-show-item tw-ml-[24px] tw-w-[280px] tw-max-w-[320px] sm:tw-ml-[30px] sm:tw-min-w-[340px] xl:tw-ml-[40px]">
                      <div class="tw-flex tw-items-center tw-pl-[16px] sm:tw-pl-[20px] md:tw-pl-[26px] xl:tw-pl-[36px]">
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/advanced-algorithms.png" />
                        </div>
                        <div class="sub-title tw-mx-[8px] sm:tw-mx-[10px] md:tw-ml-[14px] md:tw-mr-[24px]">
                          先进算法
                        </div>
                      </div>
                      <div class="color-line tw-my-[72px] tw-w-full"></div>
                      <div class="tw-flex tw-items-center tw-pl-[16px] sm:tw-pl-[20px] md:tw-pl-[26px] xl:tw-pl-[36px]">
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/deployment.png" />
                        </div>
                        <div class="sub-title tw-mx-[8px] sm:tw-mx-[10px] md:tw-ml-[14px] md:tw-mr-[24px]">
                          灵活部署
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tw-flex tw-w-full tw-justify-center tw-pb-[80px] tw-pt-[60px] md:tw-pb-[160px] md:tw-pt-[100px] xl:tw-pb-[256px]
                  xl:tw-pt-[164px]">
                <div
                  class="learn-more learn-more-small tw-flex tw-h-[88px] tw-w-[355px] tw-items-center tw-justify-center"
                  @click="() => Logger.event('官网访问_开放平台')">
                  <a class="tw-flex tw-size-full tw-items-center tw-justify-center" :href="OPEN_URL" target="_blank">
                    <div class="tw-h-[48px] tw-w-[48px]"
                      ><img class="tw-size-full" src="~/assets/images/home/new/web-global.png"
                    /></div>
                    <div class="tw-ml-[12px] tw-text-[24px] tw-font-semibold tw-text-white"> 了解更多</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="user-persona tw-w-full">
          <div class="user-persona-content tw-pb-[60px] md:tw-pb-[140px] xl:tw-pb-[284px]">
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
              <h1
                class="title text-30px tw-flex tw-flex-col tw-items-center tw-text-[36px] tw-font-bold tw-text-[#333333]">
                <span>用户画像</span>
                <div class="tw-mt-[7px] tw-h-[6px] tw-w-[32px] tw-bg-[#3555fe]"></div>
              </h1>
              <div class="tw-mt-[32px] tw-w-full md:tw-mt-[48px] xl:tw-mt-[146px]">
                <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center xl:tw-flex-row">
                  <div class="user-persona-txt tw-text-justify md:tw-max-w-[760px] xl:tw-mr-[110px]">
                    <div class="persona-tag tw-grid tw-grid-cols-5 tw-gap-x-[12px] tw-gap-y-[12px] lg:tw-gap-x-[24px]">
                      <div
                        class="tag-small tw-rounded-[4px] tw-px-[18px] tw-py-[2px] tw-text-center tw-text-[14px] tw-leading-[2]">
                        法律咨询
                      </div>
                      <div
                        class="tag-small tw-rounded-[4px] tw-px-[18px] tw-py-[2px] tw-text-center tw-text-[14px] tw-leading-[2]">
                        法律检索
                      </div>
                      <div
                        class="tag-small tw-rounded-[4px] tw-px-[18px] tw-py-[2px] tw-text-center tw-text-[14px] tw-leading-[2]">
                        法律研究
                      </div>
                      <div
                        class="tag-small tw-rounded-[4px] tw-px-[18px] tw-py-[2px] tw-text-center tw-text-[14px] tw-leading-[2]">
                        法律文书
                      </div>
                      <div
                        class="tag-small tw-rounded-[4px] tw-px-[18px] tw-py-[2px] tw-text-center tw-text-[14px] tw-leading-[2]">
                        合同生成
                      </div>
                      <div
                        class="tag-small tw-rounded-[4px] tw-px-[18px] tw-py-[2px] tw-text-center tw-text-[14px] tw-leading-[2]">
                        合同审查
                      </div>
                      <div
                        class="tag-small tw-rounded-[4px] tw-px-[18px] tw-py-[2px] tw-text-center tw-text-[14px] tw-leading-[2]">
                        案件分析
                      </div>
                      <div
                        class="tag-small tw-rounded-[4px] tw-px-[18px] tw-py-[2px] tw-text-center tw-text-[14px] tw-leading-[2]">
                        证据分析
                      </div>
                      <div
                        class="tag-small tw-rounded-[4px] tw-px-[18px] tw-py-[2px] tw-text-center tw-text-[14px] tw-leading-[2]">
                        合同分析
                      </div>
                    </div>
                    <div
                      class="text-20px text-leading-45 tw-mt-[12px] tw-w-full tw-text-[24px] tw-leading-[55px] tw-text-[#333333]">
                      为律所和律师、法律专业人士、企业和个人提供法律检索、法律研究、法律咨询、法律文书、智能合同、案件证据分析等服务，并为法律服务需求方提供智能化找律师解决方案，助力律师精准获取案源。
                    </div>
                  </div>
                  <div
                    class="persona-show tw-mt-[70px] tw-flex tw-w-full tw-flex-row tw-justify-center tw-text-[26px] tw-text-[#333333]
                      sm:tw-text-[26px] sm:tw-text-[32px] xl:tw-mt-0 xl:tw-w-auto">
                    <div class="persona-item tw-w-[280px] tw-max-w-[320px] sm:tw-min-w-[344px]">
                      <div class="tw-flex tw-items-center tw-pl-[16px] sm:tw-pl-[20px] md:tw-pl-[26px] xl:tw-pl-[36px]">
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/law-firm.png" />
                        </div>
                        <div class="sub-title tw-mx-[8px] sm:tw-mx-[10px] md:tw-ml-[14px] md:tw-mr-[24px]">
                          律所&律师
                        </div>
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/right.png" />
                        </div>
                      </div>
                      <div class="color-line tw-my-[72px] tw-w-full"></div>
                      <div class="tw-flex tw-items-center tw-pl-[16px] sm:tw-pl-[20px] md:tw-pl-[26px] xl:tw-pl-[36px]">
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/legal-professional.png" />
                        </div>
                        <div class="sub-title tw-mx-[8px] sm:tw-mx-[10px] md:tw-ml-[14px] md:tw-mr-[24px]">
                          法律专业人士
                        </div>
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/right.png" />
                        </div>
                      </div>
                    </div>
                    <div
                      class="persona-item tw-ml-[24px] tw-w-[280px] tw-max-w-[320px] sm:tw-ml-[30px] sm:tw-min-w-[340px] xl:tw-ml-[40px]">
                      <div class="tw-flex tw-items-center tw-pl-[16px] sm:tw-pl-[20px] md:tw-pl-[26px] xl:tw-pl-[36px]">
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/enterprise.png" />
                        </div>
                        <div class="sub-title tw-mx-[8px] sm:tw-mx-[10px] md:tw-ml-[14px] md:tw-mr-[24px]">
                          企业&政府
                        </div>
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/right.png" />
                        </div>
                      </div>
                      <div class="color-line tw-my-[72px] tw-w-full"></div>
                      <div class="tw-flex tw-items-center tw-pl-[16px] sm:tw-pl-[20px] md:tw-pl-[26px] xl:tw-pl-[36px]">
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/individual.png" />
                        </div>
                        <div class="sub-title tw-mx-[8px] sm:tw-mx-[10px] md:tw-ml-[14px] md:tw-mr-[24px]">个人</div>
                        <div>
                          <img
                            class="tw-h-[36px] tw-w-[36px] tw-align-middle"
                            src="~/assets/images/home/new/right.png" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="more-discoveries tw-w-full">
          <div
            class="more-discoveries-content tw-pb-[60px] tw-pt-[60px] md:tw-pb-[140px] md:tw-pt-[80px] xl:tw-pb-[284px] xl:tw-pt-[120px]">
            <div class="latest-news tw-flex tw-flex-col tw-items-center tw-justify-center">
              <div class="news-section tw-w-full">
                <!-- 顶部 tabs -->
                <div class="news-tabs tw-flex tw-justify-center tw-gap-[30px] md:tw-gap-[50px] xl:tw-gap-[80px]">
                  <div
                    v-for="tab in NEWS_TABS"
                    :key="tab.value"
                    class="news-tab-item tw-relative tw-cursor-pointer tw-pb-[8px]"
                    :class="{ active: newsType === tab.value }"
                    @click="onNewsTabChange(tab.value)">
                    {{ tab.label }}
                  </div>
                </div>
                <!-- 分类筛选 chips -->
                <div
                  class="tw-mt-[16px] tw-flex tw-flex-wrap tw-justify-center tw-gap-[8px] md:tw-mt-[20px] md:tw-gap-[10px]">
                  <div
                    v-for="cat in newsTypeList"
                    :key="cat.value"
                    class="news-filter-chip tw-cursor-pointer tw-rounded-[12px] tw-px-[10px] tw-py-[4px] md:tw-px-[14px] xl:tw-px-[16px]
                      xl:tw-py-[5px]"
                    :class="{ active: newsActiveTab === cat.value }"
                    @click="onNewsCategoryChange(cat.value)">
                    {{ cat.label }}
                  </div>
                </div>
                <!-- 卡片网格 -->
                <div
                  class="tw-mt-[24px] tw-grid tw-grid-cols-1 tw-gap-[16px] tw-px-[16px] md:tw-grid-cols-2 md:tw-gap-[32px] md:tw-px-[40px]
                    xl:tw-mt-[32px] xl:tw-grid-cols-3 xl:tw-gap-[48px] xl:tw-px-[88px]">
                  <nuxt-link
                    v-for="item in newsItems"
                    :key="item.id"
                    class="news-card tw-block tw-overflow-hidden tw-rounded-[8px] tw-bg-white"
                    :to="`/news/${newsType}/${item.id}`"
                    target="_blank">
                    <div class="news-card-img">
                      <img class="tw-h-full tw-w-full tw-object-cover" v-if="item.pictureUrl" :src="item.pictureUrl" />
                    </div>
                    <div class="tw-mt-[20px] md:tw-mt-[30px] xl:tw-mt-[42px]">
                      <div class="tw-text-[12px] tw-text-[#999] md:tw-text-[14px] xl:tw-text-[1.125rem]">
                        {{ item.label }}
                      </div>
                      <div
                        class="tw-mt-[10px] tw-line-clamp-2 tw-text-[16px] tw-font-medium tw-text-[#1f1f1f] md:tw-mt-[14px] md:tw-text-[20px]
                          xl:tw-mt-[20px] xl:tw-text-[2rem]">
                        {{ item.title }}
                      </div>
                    </div>
                  </nuxt-link>
                </div>
                <!-- 分页导航 -->
                <div
                  class="tw-mt-[24px] tw-flex tw-items-center tw-justify-center tw-gap-[16px] md:tw-mt-[32px] md:tw-gap-[20px] xl:tw-mt-[40px]
                    xl:tw-gap-[24px]">
                  <div
                    class="news-nav-btn tw-flex tw-h-[40px] tw-w-[52px] tw-cursor-pointer tw-items-center tw-justify-center xl:tw-h-[52px]
                      xl:tw-w-[68px]"
                    @click="onNewsPageChange(newsPageNo - 1)">
                    <img
                      class="tw-h-[16px] tw-w-[16px] xl:tw-h-[20px] xl:tw-w-[20px]"
                      src="~/assets/images/home/new/left.png" />
                  </div>
                  <div class="tw-flex tw-gap-[8px] xl:tw-gap-[10px]">
                    <div
                      v-for="page in visiblePages"
                      :key="page"
                      class="news-page-dot tw-cursor-pointer"
                      :class="{ active: page === newsPageNo }"
                      @click="onNewsPageChange(page)"></div>
                  </div>
                  <div
                    class="news-nav-btn tw-flex tw-h-[40px] tw-w-[52px] tw-cursor-pointer tw-items-center tw-justify-center xl:tw-h-[52px]
                      xl:tw-w-[68px]"
                    @click="onNewsPageChange(newsPageNo + 1)">
                    <img
                      class="tw-h-[16px] tw-w-[16px] xl:tw-h-[20px] xl:tw-w-[20px]"
                      src="~/assets/images/home/new/right.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <client-only>
      <AdvertiseModal platform="1" />
    </client-only>
  </div>
</template>

<style lang="less" scoped>
  .container {
    width: 100%;
    overflow-wrap: break-word;

    .banner-home {
      .banner-content {
        width: 100%;
        height: 880px;
        background-image: url("~/assets/images/home/new/banner-core.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;

        .navigation-product {
          .link-ai {
            color: #fff;
            background: linear-gradient(90deg, #37f 0%, #9c9cff 100%);
          }

          .link-paralegal {
            color: #fff;
            background: linear-gradient(90deg, #8d91ff 0%, #e0d5ff 100%);
          }

          .link-search {
            background: linear-gradient(90deg, #e5ddff 0%, #fbfbff 100%);

            a {
              color: transparent;
              background-image: linear-gradient(360deg, #5965a4 0%, #6e63b1 100%);
              background-clip: text;
            }
          }

          a {
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
          }
        }
      }
    }

    .free-trial {
      a {
        display: block;
        width: 214px;
        height: 72px;
        font-size: 27px;
        font-weight: 600;
        line-height: 72px;
        color: #fff;
        text-align: center;
        background: linear-gradient(90deg, #0a5cff 0%, #66f 100%);
        border-radius: 5px;
      }
    }

    .corporate-achievements {
      background: linear-gradient(90deg, #4d3a99 0%, #6184ff 45%, #8d7bff 100%);
    }

    .products-sticky-nav {
      .ai-product-content {
        width: 100%;

        .ai-product-item {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 0;
          height: 100px;
          background: linear-gradient(315deg, #f3f4ff 0%, #fafafa 100%);
          border-radius: 12px;
          box-shadow: 0 4px 16px 0 rgba(0, 17, 62, 12%);

          @media screen and (min-width: 1024px) {
            height: 148px;
            border-radius: 16px;
          }

          .producet-size {
            width: 85% !important;
          }

          .product-icon {
            display: flex;
            flex-shrink: 0;
            align-items: center;
            justify-content: center;
            width: 56px;
            height: 56px;
            margin-right: 12px;
            background: #fff;
            border: 1px solid #f1f1f1;
            border-radius: 10px;
            box-shadow: 0 4px 16px 0 rgba(0, 16, 102, 8%);

            @media screen and (min-width: 1024px) {
              width: 102px;
              height: 102px;
              margin-right: 34px;
              border-radius: 16px;
            }

            @media screen and (max-width: 1023px) {
              img {
                width: 32px !important;
                height: auto !important;
              }
            }
          }

          .tw-text-\[20px\] {
            font-size: 14px;

            @media screen and (min-width: 1024px) {
              font-size: 20px;
            }
          }

          .tw-text-\[\#828596\] {
            font-size: 11px;

            @media screen and (min-width: 1024px) {
              font-size: 14px;
            }
          }

          .paralegal-free-trial {
            width: 64px;
            font-size: 10px;
            color: #fff;
            background: linear-gradient(90deg, #0a5cff 0%, #66f 100%);
            border-radius: 4px;

            @media screen and (min-width: 1024px) {
              width: 88px;
              font-size: 12px;
            }

            a {
              display: block;
              width: 100%;
              height: 24px;
              line-height: 24px;
              text-align: center;

              @media screen and (min-width: 1024px) {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .products-wrapper {
      background: linear-gradient(180deg, #ebf1ff 0%, #fff 50%, #fafcff 100%);
    }

    .legal-ai {
      //background: linear-gradient(180deg, #ebf1ff 0%, #fff 50%, #fafcff 100%);

      .ai-divide {
        .divide-line {
          border: 1px solid;
          border-image: linear-gradient(90deg, rgba(54, 88, 255, 100%), rgba(101, 193, 252, 0%)) 1 1;
        }

        .rotate-180 {
          transform: rotateY(180deg);
        }

        .divide-title-color {
          color: transparent;
          background-image: linear-gradient(360deg, #0a5cff 0%, #66f 100%);
          background-clip: text;
        }
      }

      .ai-product {
        .ai-product-content {
          width: 100%;

          .ai-product-item {
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
            min-width: 0;
            height: 148px;
            background: linear-gradient(315deg, #f3f4ff 0%, #fafafa 100%);
            border-radius: 16px;
            box-shadow: 0 4px 16px 0 rgba(0, 17, 62, 12%);

            &:first-child {
              margin-left: 0;
            }

            .product-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 102px;
              height: 102px;
              margin-right: 34px;
              background: #fff;
              border: 1px solid #f1f1f1;
              border-radius: 16px;
              box-shadow: 0 4px 16px 0 rgba(0, 16, 102, 8%);
            }

            .paralegal-free-trial {
              width: 88px;
              font-size: 12px;
              color: #fff;
              background: linear-gradient(90deg, #0a5cff 0%, #66f 100%);
              border-radius: 4px;

              a {
                display: block;
                width: 100%;
                height: 32px;
                line-height: 32px;
                text-align: center;
              }
            }
          }
        }

        .ai-introduction {
          .ai-xiaoli-title {
            .ai-xiaoli-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 112px;
              height: 112px;
              background: #fff;
              border: 1px solid #f1f1f1;
              border-radius: 22px;
              box-shadow: 0 6px 22px 0 rgba(0, 16, 102, 8%);
            }
          }

          .product-features {
            .product-features-introduction {
              .ai-free-trial {
                a {
                  display: block;
                  width: 214px;
                  height: 72px;
                  font-size: 27px;
                  font-weight: 600;
                  line-height: 72px;
                  color: #fff;
                  text-align: center;
                  background: linear-gradient(90deg, #0a5cff 0%, #66f 100%);
                  border-radius: 5px;
                }
              }
            }
          }
        }
      }
    }

    .deli-search {
      background: linear-gradient(180deg, #ebf1ff 0%, #fff 50%, #fafcff 100%);

      .deli-search-content {
        .deli-search-title {
          .deli-search-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 112px;
            height: 112px;
            background: #fff;
            border: 1px solid #f1f1f1;
            border-radius: 16px;
            box-shadow: 0 4px 16px 0 rgba(0, 16, 102, 8%);
          }
        }
      }
    }

    .deli-paralegal {
      background: linear-gradient(180deg, #ebf1ff 0%, #fff 50%, #fafcff 100%);

      .deli-paralegal-title {
        .deli-paralegal-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 112px;
          height: 112px;
          background: #fff;
          border: 1px solid #f1f1f1;
          border-radius: 16px;
          box-shadow: 0 4px 16px 0 rgba(0, 16, 102, 8%);
        }
      }
    }

    .triangle-bg {
      background: linear-gradient(180deg, rgba(53, 87, 254, 3%) 0%, rgba(53, 85, 254, 2%) 100%);
      border-radius: 80px;
      transform: rotate(45deg);
    }

    .more-info {
      background: linear-gradient(180deg, #ebf1ff 0%, #fff 50%, #fafcff 100%);

      .more-discoveries {
        .news-section {
          .news-tabs {
            .news-tab-item {
              font-size: 20px;
              color: #666;
              transition: color 0.2s;

              @media screen and (min-width: 768px) {
                font-size: 28px;
              }

              @media screen and (min-width: 1280px) {
                font-size: 36px;
              }

              &.active {
                font-weight: bold;
                color: #1f1f1f;

                &::after {
                  position: absolute;
                  bottom: 0;
                  left: 50%;
                  width: 24px;
                  height: 4px;
                  content: "";
                  background: #3555fe;
                  border-radius: 2px;
                  transform: translateX(-50%);

                  @media screen and (min-width: 1280px) {
                    width: 32px;
                    height: 6px;
                  }
                }
              }
            }
          }

          .news-filter-chip {
            font-size: 14px;
            color: #333;
            background: #fff;
            transition: all 0.2s;

            @media screen and (min-width: 768px) {
              font-size: 18px;
            }

            @media screen and (min-width: 1280px) {
              font-size: 24px;
            }

            &.active {
              color: #fff;
              background: #3555fe;
            }
          }

          .news-card {
            padding: 24px 20px;
            box-shadow: 0 4px 16px rgba(0, 0, 0, 6%);
            transition:
              box-shadow 0.2s,
              transform 0.2s;

            @media screen and (min-width: 768px) {
              padding: 40px 36px;
            }

            @media screen and (min-width: 1280px) {
              padding: 80px 60px;
            }

            &:hover {
              box-shadow: 0 8px 24px rgba(66, 133, 244, 15%);
              transform: translateY(-2px);
            }

            .news-card-img {
              width: 100%;
              height: auto;
              aspect-ratio: 430 / 270;
              overflow: hidden;
            }
          }

          .news-nav-btn {
            background: rgba(255, 255, 255, 90%);
            border: 1px solid rgba(10, 92, 255, 50%);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 10%);
            transition: all 0.2s;

            &:hover {
              background: #eef2ff;
            }
          }

          .news-page-dot {
            width: 10px;
            height: 10px;
            background: #ccc;
            border-radius: 50%;
            transition:
              background 0.2s,
              transform 0.2s;

            &.active {
              background: #3555fe;
              transform: scale(1.3);
            }

            &:hover {
              background: #aaa;
            }
          }
        }
      }

      .user-persona {
        .persona-tag {
          .tag-small {
            color: transparent;
            background: linear-gradient(360deg, #0a5cff 0%, #66f 100%);
            background-clip: text;
            border: 0.5px solid #0a5cff;
          }
        }
      }

      .api-integration {
        .learn-more {
          background: linear-gradient(90deg, #0a5cff 0%, #66f 100%);
          border-radius: 8px;
        }
      }
    }

    .color-line {
      height: 0;
      border: 1px solid;
      border-image: linear-gradient(90deg, rgba(10, 92, 255, 40%), rgba(102, 102, 255, 30%)) 1 1;
    }

    h1,
    h2,
    h3 {
      margin-bottom: 0;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 540px) {
    .achievements-sm {
      flex-direction: column;
      align-items: start;
      justify-content: center;
      width: fit-content;

      .deli-align-self {
        align-self: start;
      }
    }

    .deli-mt-0 {
      margin-top: 0;
    }

    .deli-mx-auto {
      margin-right: auto;
      margin-left: auto;
    }

    .user-persona {
      .persona-show {
        justify-content: space-between;
        font-size: 22px;

        .persona-item {
          width: 230px;
          margin-left: 0;

          img {
            width: 22px;
            height: 22px;
          }
        }

        .sub-title {
          margin-right: 6px;
          margin-left: 6px;
        }
      }
    }

    .api-integration {
      .api-show {
        justify-content: space-between;
        font-size: 22px;

        .api-show-item {
          width: 230px;
          margin-left: 0;

          img {
            width: 22px;
            height: 22px;
          }
        }

        .sub-title {
          margin-right: 6px;
          margin-left: 6px;
        }
      }
    }

    // 分页控制器整体容器
    .pagination-controls {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    // 分页控制器整体布局
    .custom-swiper-pagination {
      position: static !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: auto !important;
    }

    // 左右箭头按钮样式
    .slideshow-btn {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      background-color: rgba(255, 255, 255, 80%);
      border: 1px solid rgba(0, 0, 0, 10%);
      border-radius: 2px;
      transition: all 0.3s ease;

      &:hover {
        background-color: rgba(10, 92, 255, 10%);
        border-color: rgba(10, 92, 255, 20%);
      }
    }

    .custom-swiper-pagination :deep(.swiper-pagination-bullet) {
      width: 12px !important;
      height: 12px !important;
      margin: 0 4px !important;
      cursor: pointer !important;
      background: rgba(10, 92, 255, 30%) !important;

      &.swiper-pagination-bullet-active {
        background: rgba(10, 92, 255, 100%) !important;
        transform: scale(1.1) !important;
      }
    }

    .learn-more-small {
      width: 243px;
      height: 61px;
    }

    .tag-small {
      max-width: 80px;
    }

    .ai-lawyer-txt {
      width: 132px;
      height: 33px;
    }

    .link-btn {
      width: 126px;
      height: 42px;
      font-size: 16px;
      line-height: 42px;
    }

    .container {
      .free-trial {
        a {
          width: 166px;
          height: 56px;
          font-size: 22px;
          line-height: 56px;
        }
      }
    }

    .text-14px {
      font-size: 14px;
    }

    .text-18px {
      font-size: 18px;
    }

    .text-16px {
      font-size: 16px;
    }

    .text-20px {
      font-size: 20px;
    }

    .text-26px {
      font-size: 26px;
    }

    .text-30px {
      font-size: 30px;
    }

    .text-34px {
      font-size: 34px;
    }

    .text-leading-45 {
      line-height: 45px;
    }

    // .carousel-height {
    //   height: 584px;
    // }
  }

  @media screen and (min-width: 480px) and (max-width: 640px) {
    .ai-divide {
      .divide-line {
        width: 46px;
      }
    }

    .news-carousel-content {
      padding-right: 83px;
      padding-left: 83px;
    }

    .custom-swiper-pagination :deep(.swiper-pagination-bullet) {
      width: 14px !important;
      height: 14px !important;
      margin: 0 5px !important;
      cursor: pointer !important;
      background: rgba(10, 92, 255, 30%) !important;

      &.swiper-pagination-bullet-active {
        background: rgba(10, 92, 255, 100%) !important;
        transform: scale(1.1) !important;
      }
    }

    .user-persona {
      .persona-show {
        font-size: 24px;

        .persona-item {
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    .api-integration {
      .api-show {
        font-size: 24px;

        .api-show-item {
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }

    .carousel-img-width {
      max-width: 290px;
    }
  }

  @media screen and (min-width: 370px) and (max-width: 460px) {
    .ai-product {
      .ai-product-content {
        .ai-product-item {
          width: 360px !important;
          height: 137px !important;

          .producet-size {
            width: 89%;
          }
        }
      }
    }

    .user-persona {
      .persona-show {
        justify-content: space-between;
        font-size: 17px;

        .persona-item {
          width: 160px;
          margin-left: 0;

          img {
            width: 17px;
            height: 17px;
          }
        }

        .sub-title {
          margin-right: 3px;
          margin-left: 3px;
        }
      }
    }

    .api-integration {
      .api-show {
        justify-content: space-between;
        font-size: 18px;

        .api-show-item {
          width: 160px;
          margin-left: 0;

          img {
            width: 18px;
            height: 18px;
          }
        }

        .sub-title {
          margin-right: 4px;
          margin-left: 4px;
        }
      }
    }
  }

  @media screen and (max-width: 370px) {
    .user-persona {
      .persona-show {
        justify-content: space-between;
        font-size: 16px;

        .persona-item {
          width: 170px;
          margin-left: 0;

          img {
            width: 16px;
            height: 16px;
          }
        }

        .sub-title {
          margin-right: 2px;
          margin-left: 2px;
        }
      }
    }

    .api-integration {
      .api-show {
        justify-content: space-between;
        font-size: 16px;

        .api-show-item {
          width: 170px;
          margin-left: 0;

          img {
            width: 16px;
            height: 16px;
          }
        }

        .sub-title {
          margin-right: 2px;
          margin-left: 2px;
        }
      }
    }
  }

  @media screen and (max-width: 391px) {
    .ai-product {
      .ai-product-content {
        .ai-product-item {
          width: 340px !important;
          height: 138px !important;

          .producet-size {
            width: 89%;
          }
        }
      }
    }

    .link-paralegal {
      margin-left: 12px;
    }

    .link-search {
      margin-left: 12px;
    }
  }

  @media screen and (max-width: 480px) {
    .ai-divide {
      .divide-line {
        display: none;
      }
    }

    .news-carousel-content {
      padding-right: 10px;
      padding-left: 10px;

      .news-img {
        height: 250px;
      }
    }

    .carousel-img-width {
      max-width: 260px;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 420px) {
    .news-carousel-content {
      padding-right: 0;
      padding-left: 0;

      .news-img {
        height: 230px;
      }
    }
  }

  @media screen and (min-width: 1280px) {
    .custom-swiper-pagination :deep(.swiper-pagination-bullet) {
      width: 16px !important;
      height: 16px !important;
      margin: 0 6px !important;
      cursor: pointer !important;
      background: rgba(10, 92, 255, 30%) !important;

      &.swiper-pagination-bullet-active {
        background: rgba(10, 92, 255, 100%) !important;
        transform: scale(1.1) !important;
      }
    }
  }
</style>
